// Lightweight social-share helpers (intent URLs, no SDKs).
const SITE = typeof window !== "undefined" ? window.location.origin : "";

export function shareX(text) {
  const u = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(SITE)}`;
  window.open(u, "_blank", "noopener,width=600,height=500");
}

export function shareReddit(title) {
  const u = `https://www.reddit.com/submit?title=${encodeURIComponent(title)}&url=${encodeURIComponent(SITE)}`;
  window.open(u, "_blank", "noopener,width=900,height=700");
}

export function copyShare(text) {
  navigator.clipboard?.writeText(`${text} — via Dynasty Metrics`);
}
